export const SIGN_IN = '/signin';
export const HOME = '/home';
export const EDITOR = (uid?: string) =>
  '/editor/' + (uid ? uid : ':uid');
